import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ColumnMode } from '@swimlane/ngx-datatable';
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReporteData } from 'src/app/models';
import { ReporteriaService } from 'src/app/services/convenio/reporteria.service';
import { TransportistaService } from 'src/app/services/convenio/transportista.service';
import { TipoVehiculoService } from 'src/app/services/tipo-vehiculo.service';
import { AppState } from 'src/app/state/app.state';
import { selectUser } from 'src/app/state/selectors/user.selectors';

@Component({
  selector: 'app-reporte-transportista',
  templateUrl: './reporte-transportista.component.html',
  styleUrls: ['./reporte-transportista.component.scss']
})
export class ReporteTransportistaComponent implements OnInit {
  formBusqueda:FormGroup;
  totalDineroCobrado:number = 0;
  tipoVehiculos:any[] = [];
  transportes:any[] = [];
  carriles:any[] = [];
  //DataTable
  loadingIndicator:boolean = false;
  rows: ReporteData = null;
  colums = [{ name: 'TRANSPORTISTA' }, { name:'NO.BOLETO' }, { name: 'CARRIL' },{ name: 'FECHA CRUCE' },{ name:'HORA CRUCE' }, { name: 'TIPO VEHICULO' }, { name: 'TARIFA'}];
  ColumnMode = ColumnMode;
  constructor(
    private formBuider:FormBuilder,
    private store: Store<AppState>,
    private transportistaService:TransportistaService,
    private vehiculoService:TipoVehiculoService,
    private reporteService:ReporteriaService,
    private ngxUiLoaderService:NgxUiLoaderService,
    private toastr:ToastrService,
  ) { }

  ngOnInit() {
    this.createForm();
    this.getData();
  }

  createForm() {
    this.formBusqueda = this.formBuider.group({
      transportista : [''],
      fechaInicio : [''],
      fechaFin : [''],
      carril : [''],
      vehiculos : ['']
    },{ validators: [ this.validaFechaFin() ] });

    this.formBusqueda.get('fechaInicio').setValue(moment().format('YYYY-MM-DD'));//fecha actual
    this.formBusqueda.get('fechaFin').setValue(moment().add(1, 'day').format('YYYY-MM-DD')); //fecha + 1 dia
  }

 
  validaFechaFin() {  // validate fecha_Fin posterior a fechaInicio  
    return (formGroup:AbstractControl): ValidationErrors | null => {
      const fechaInicio = formGroup.get('fechaInicio')?.value;
      const fechaFin = formGroup.get('fechaFin')?.value;
      if (fechaInicio != null && fechaFin != null) {
        let fecha_I = moment(fechaInicio, 'YYYY-MM-DD');
        let fecha_F = moment(fechaFin, 'YYYY-MM-DD');
        if (fecha_I.isAfter(fecha_F)) { //Fecha Inicio es posterior a fecha Final
          formGroup.get('fechaFin')?.setErrors({ dateError: true})
          this.toastr.error('Verificar el campo de "fecha fin" debe ser mayor a la inicial.', '', { positionClass: 'toast-bottom-right' })
          return { dateError:true }
        }
      }
      formGroup.get('fechaFin')?.setErrors(null);
      return null;
    }
  }

  getCasetaUser(){
    let casetaTroncal;
    this.store.select(selectUser).subscribe( usuario => { // Obtener info del usuario
      casetaTroncal = usuario.caseta_usuario.find(caseta => caseta.tipo === 1);// Obtener caseta troncal
    });
    return casetaTroncal;
  }
  

  getData(){//obtener carriles, transportista y vehiculos
    let caseta = this.getCasetaUser();
    this.vehiculoService.getClasificacionVehiculo() //get all clasificaciones vehiculo
    .subscribe(clasificaciones => { 
      this.tipoVehiculos = clasificaciones;
    });

    this.transportistaService.getTransportistas()
    .subscribe(transportistas => {
      this.transportes = transportistas;
    });

    this.reporteService.getCarriles(caseta.id)
    .then(carriles => {
      this.carriles = carriles;
    });

  }

  searchData(){
    this.loadingIndicator = true;
    this.reporteService.getDataReporte(1, { ...this.formBusqueda.value, 'tipoReporte': 4})//reporte transportista
    .subscribe(infoBoletos => {
       this.rows = infoBoletos;
       this.calcularTotal();
       this.loadingIndicator = false;
     });
  }

  setPage(event){
    this.loadingIndicator = true;
    let page = event.offset + 1;
    this.reporteService.getDataReporte(page, { ...this.formBusqueda.value, 'tipoReporte': 4})
    .subscribe(infoBoletos => {
       this.rows = infoBoletos;
       this.calcularTotal();
       this.loadingIndicator = false;
     });
  }

  exportFileExcel(){
    this.ngxUiLoaderService.start('3');
    let urlExcel:string;
    this.reporteService.descargarArchivo( {...this.formBusqueda.value, 'tipoReporte': 4})
    .then((file:Blob) => {
        let urlDownload = this.reporteService.downloadExcel(file,`reporte_transportista_${moment().format('YYYY-MM-DD')}.xlsx`);
        if(urlDownload != ''){
          urlExcel = urlDownload;
          this.ngxUiLoaderService.stop('3');
          return this.toastr.success('Se ha descargado con éxito el archivo Excel', '', { positionClass: 'toast-bottom-right' })  
        }
    })
    .catch(error => {
      console.log(error);
      this.ngxUiLoaderService.stop('3');
      return this.toastr.error(`Por favor intenta de nuevo, ${error}`, 'Error al descargar', { positionClass: 'toast-bottom-right' })
    })
    .finally(() => {
      URL.revokeObjectURL(urlExcel);
    });
  }

  calcularTotal(){
    this.totalDineroCobrado = 0;
    this.rows.data.forEach(boleto => {
        this.totalDineroCobrado +=  parseFloat(boleto.monto);
    });
  }
}
